import {
  ERROR_CODES,
  type ErrorCode,
  isErrorCode,
} from "../constants/errorCodes";
import type { CourseCertificateUploadError } from "../models/courseCertificate";

const ERROR_CODE_MESSAGES: Record<ErrorCode, string> = {
  [ERROR_CODES.BATCH_LIMIT_EXCEEDED]:
    "Du kan ikke uploade flere filer i én omgang.",
  [ERROR_CODES.UNSUPPORTED_FILE_TYPE]: "Filen skal være en PDF.",
  [ERROR_CODES.FILE_TOO_LARGE]: "Filen er for stor.",
  [ERROR_CODES.EMPTY_FILE]: "Filen er tom.",
  // CLE's AI analysis takes at most 50 pages. Shared by the course certificate
  // and insurance policy uploads, so the text names both.
  [ERROR_CODES.TOO_MANY_PAGES]:
    "Filen har over 50 sider. Upload kun selve kursusbeviset eller policen.",
  [ERROR_CODES.DUPLICATE]: "Denne fil er allerede uploadet.",
  [ERROR_CODES.UPLOAD_FAILED]: "Filen kunne ikke uploades. Prøv igen.",
};

const UNKNOWN_ERROR_MESSAGE = "Der opstod en fejl under upload. Prøv igen.";

export const getErrorCodeMessage = (errorCode: string): string => {
  if (isErrorCode(errorCode)) {
    return ERROR_CODE_MESSAGES[errorCode];
  }

  return UNKNOWN_ERROR_MESSAGE;
};

export const formatCourseCertificateUploadError = (
  error: CourseCertificateUploadError,
): string => `${error.fileName}: ${getErrorCodeMessage(error.errorCode)}`;
